export default __webpack_public_path__ + "static/ethlogo-540ded210655d84d1cda00420bef731b.png";